import { ArrowUturnUpIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";

const ReplyButton = ({
  disabled = false,
  onClick,
  isActive = false,
}: {
  disabled: boolean;
  onClick: () => void;
  isActive: boolean;
}) => {
  return (
    <button
      className={clsx(
        "group flex items-center space-x-1 text-sm font-normal transition ease-out hover:text-zinc-950",
        {
          "pointer-events-none": disabled,
          "text-zinc-500": !isActive,
          "text-zinc-950": isActive,
        }
      )}
      onClick={onClick}
      disabled={disabled}
      aria-label="Toggle like"
    >
      <div>
        <ArrowUturnUpIcon
          className={clsx("size-4 transition ease-out", {
            "rotate-90": !isActive,
            "rotate-0": isActive,
          })}
        />
      </div>
      <div className={clsx("tabular-nums")}>Reply</div>
    </button>
  );
};

export default ReplyButton;
